import React, { useContext } from "react"
import { SpaceProfileContext } from "../context"
import PropTypes from "prop-types"
import isDd from "../../../utils/isDd"
import isOnDemand from "../../../utils/isOnDemand"

import "./index.less"

const StickyBar = ({
  spProfile,
  spaceSummary = {},
  isCms = false,
  cmsProfile = {},
  calendar = { calendar: {} },
}) => {
  const {
    commonData: {
      bookTourComplete,
      filteredOptions,
      isDaily,
      displayPrice,
      teamSize,
    },
    actions: { setValue, setBookTour, setGetInTouch },
  } = useContext(SpaceProfileContext)

  const isDedicatedDesks = isDd(spaceSummary.space_type)

  if (isOnDemand()) {
    return (
      <div className={`floating-bar d-xl-none`}>
        <div className="content-box space-contact" />
        <div className="content-box space-cta">
          <button
            onClick={(e) => {
              e.stopPropagation()
              setValue({ onDemandStep: 1 })
            }}
            className="btn btn-primary"
          >
            Reserve Now
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className={`floating-bar`}>
      <div className="content-box space-contact">
        {spProfile.user_image_url && (
          <img
            src={
              spProfile.user_image_url ||
              require("../../../images/icon.png").default
            }
            alt={spProfile.contact_name || "Workplace One"}
            className="user-image"
          />
        )}
        <div className="desc-block">
          {spProfile.contact_name && (
            <h3>{spProfile.contact_name || "Workplace One"}</h3>
          )}
          {spProfile.contact_position && <p>{spProfile.contact_position}</p>}
        </div>
      </div>
      <div className="content-box space-cta">
        {!isCms && filteredOptions.length > 0 && (
          <div className="desc-block">
            <h3 className={displayPrice ? "" : "mt-2 d-none d-sm-block"}>
              {displayPrice ? (
                mapPrice(filteredOptions, isDedicatedDesks ? teamSize : 1)
              ) : (
                <small>Contact for pricing</small>
              )}
            </h3>
            {displayPrice && <p>per month</p>}
          </div>
        )}

        {!!calendar.calendar.calendar_id && (
          <button
            className="btn btn-primary"
            disabled={bookTourComplete}
            onClick={() => setBookTour(true)}
          >
            {bookTourComplete ? "Call scheduled" : "Schedule a Call"}
          </button>
        )}
        <button
          className="btn btn-primary border"
          onClick={() => setGetInTouch(true)}
        >
          Get in Touch
        </button>
      </div>
    </div>
  )
}

export default StickyBar

StickyBar.propTypes = {
  spProfile: PropTypes.object,
  displayPrice: PropTypes.bool,
  spaceSummary: PropTypes.object,
}

const mapPrice = (options, teamSize = 1) => {
  let price = 0
  let multiple = ""
  for (let i = 0; i < options.length; i++) {
    const option = options[i]
    const optionPrice = option.price * Number(teamSize)

    if (!price || price > optionPrice) {
      price = optionPrice
    }
    if (price && price < optionPrice) {
      multiple = "+"
    }
  }
  return `$${price.toLocaleString("en")}${multiple}`
}
